import { render, staticRenderFns } from "./OrderSales.vue?vue&type=template&id=16c59626&scoped=true"
import script from "./OrderSales.vue?vue&type=script&lang=js"
export * from "./OrderSales.vue?vue&type=script&lang=js"
import style0 from "./OrderSales.vue?vue&type=style&index=0&id=16c59626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c59626",
  null
  
)

export default component.exports